import { useRouteError, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { GlobalErrorScreen } from "./GlobalErrorScreen";
import { logger } from "@/services/logger";
import { isChunkLoadError, reloadOnceForChunkError } from "@/utils";

/**
 * RouteError
 *
 * Bridges React Router's error channel to {@link GlobalErrorScreen}. Used as
 * the router `errorElement`; logs the failure and offers navigation back to a
 * known-good route rather than a hard reload.
 *
 * A lazy route chunk 404ing (stale hash from a deploy that's since replaced
 * it) isn't fixable by client-side navigation — the importing bundle still
 * references the same missing URL — so that case gets a one-time full reload
 * instead of the error screen.
 */
export function RouteError() {
  const error = useRouteError();
  const navigate = useNavigate();

  useEffect(() => {
    logger.error("router", "Route error", error);
    if (isChunkLoadError(error)) {
      reloadOnceForChunkError();
    }
  }, [error]);

  return (
    <GlobalErrorScreen
      error={error}
      resetLabel="Back to Chat"
      onReset={() => navigate("/chat", { replace: true })}
    />
  );
}
